<script>
	import {mapGetters} from 'vuex'
	import {db, increment, joinSession} from '@/js/firebase'

	export default {
		name: 'Join',
		data() {
			return {
				componentName: 'Join',
				code: '',
				secret: '',
				error: null,
				valid: true,
				codeRules: [
					v =>
						(v > 99999 && v < 1000000) ||
						'This code appears to be invalid. Please try again or check with your partner.',
				],
				secretRules: [
					v =>
						v !== '' ||
						'Please be sure to enter the secret word given to you by your partner.',
				],
			}
		},
		components: {},
		props: [],
		computed: {
			...mapGetters(['session', 'account']),
		},
		methods: {
			joinSession(id) {
				joinSession(this.code, this.secret)
				// this.error = null
				// this.$refs.form.resetValidation()
				// if (!this.$refs.form.validate()) {
				// 	return
				// }
				// let session = db
				// 	.collection('session')
				// 	.where('code', '==', +this.code)
				// 	.where('secret', '==', this.secret)
				// // .where('userCount', '==', 1)
				// session
				// 	.get()
				// 	.then(querySnapshot => {
				// 		console.log(querySnapshot)
				// 		console.log(querySnapshot.length)
				// 		if (querySnapshot.size === 0) {
				// 			return (this.error =
				// 				'Unfortunately that code did not work. Please check with your partner and be sure the code and secret are correct. Please remember the secret is case sensitive.')
				// 		}
				// 		querySnapshot.forEach(doc => {
				// 			console.log(doc.id, ' => ', doc.data())
				// 			this.$store.dispatch('setSession', doc.data())
				// 			db.collection('session')
				// 				.doc(doc.id)
				// 				.set(
				// 					{
				// 						codeExpires: new Date(),
				// 						users: {
				// 							[this.account.uid]: new Date(),
				// 						},
				// 						userCount: increment(1),
				// 					},
				// 					{merge: true}
				// 				)
				// 				.then(resp => {
				// 					console.log({resp})
				// 					this.$router.replace({name: 'session', params: {id: doc.id}})
				// 				})
				// 				.catch(err => {
				// 					console.log({err})
				// 				})
				// 		})
				// 	})
				// 	.catch(err => {
				// 		console.log({err})
				// 	})

				// session.onSnapshot(doc => {
				// 	console.log('snap', doc)
				// 	if (doc.empty) {
				// 		return (this.error = 'Invalid code or secret')
				// 	}
				// 	this.$store.dispatch('setSession', doc.data())
				// 	this.$route.params.id = doc.id
				// 	let route = {
				// 		name: 'sesson',
				// 		params: {id: doc.id},
				// 	}
				// 	this.$router.replace(route)
				// })
			},
			validateSession() {
				this.error = null
				let session = db
					.collection('session')
					.where('code', '==', this.code)
					.where('secret', '==', this.secret)
				session.get(async doc => {
					console.log('snap', doc)
					if (doc.empty) {
						return (this.error = 'Invalid code or secret')
					}
					await this.joinSession(doc.id)

					this.$store.dispatch('setSession', doc.data())
					this.$route.params.id = doc.id
					let route = {
						name: 'sesson',
						params: {id: doc.id},
					}
					this.$router.replace(route)
				})
			},
		},
		mounted() {
			// Called after the instance has just been mounted where el is replaced by the newly created vm.el. If the root instance is mounted to an in-document element, vm.el will also be in-document when mounted is called.
			this.$nextTick(() => {
				// console.log('<Join> is ready and attached to the dom', this)
			})
		},
	}
</script>
<!-- ******************************************************************* -->
<template>
	<v-card>
		<v-card-title>Join a ToDo</v-card-title>
		<v-card-text>
			<v-form ref="form" v-model="valid" lazy-validation>
				<v-text-field
					:rules="codeRules"
					label="Code"
					v-model="code"
					type="number"
					validate-on-blur
				>
				</v-text-field>

				<v-text-field label="Secret Word" :rules="secretRules" v-model="secret">
				</v-text-field>
			</v-form>
			<div v-if="error" class="v-messages theme--light error--text">
				<div class="v-messages__wrapper">
					<div class="v-messages__message">
						Unfortunately that code and/or secret did not work. Please check
						with your partner and be sure the code and secret are correct.
						Please remember the secret is case sensitive.
					</div>
				</div>
			</div>
		</v-card-text>
		<v-card-actions>
			<v-btn :disabled="!valid" @click="joinSession" flat color="orange"
				>Join Todo</v-btn
			>
		</v-card-actions>
	</v-card>
</template>
<!-- ******************************************************************* -->
<style>
	input[type='number']::-webkit-outer-spin-button,
	input[type='number']::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	input[type='number'] {
		-moz-appearance: textfield;
	}
</style>
